export default {
  INVALID_TRACKING_NUMBER: 3003,
  TRACKING_NOT_FOUND: 3220,
  ZIP_CODE_OUT_OF_RANGE: 3101
};
